import React from "react";

const Imagen = ({ imagen }) => {
  const { largeImageURL, likes, previewURL, tags, views } = imagen;

  return (
    <div className="m-2 rounded  border border-dark">
      <div className="card ">
        <img src={previewURL} alt={tags} className="card-img-top" />
      </div>
      <div
        className="card-body  text-center"
        style={{ backgroundColor: "#e5e7eb" }}
      >
        <p className="card-text">{likes} Me Gusta</p>
        <p className="card-text">{views} Vistas</p>
      </div>
      <div
        className="card-footer d-flex justify-content-center"
        style={{ backgroundColor: "#9ca3af" }}
      >
        <a
          href={largeImageURL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary btn-blocked"
        >
          Ver Imágen
        </a>
      </div>
    </div>
  );
};

export default Imagen;
